import { AsyncPipe } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  effect,
  inject,
} from '@angular/core'

import { Observable, map, shareReplay } from 'rxjs'

import {
  FLX_MODAL_DATA,
  FlxButtonModule,
  FlxModalModule,
  FlxModalService,
} from '@flowx/angular-ui-toolkit'
import {
  DataModelAttribute,
  DataModelEntity,
  DataModelPathReferences,
  DataModelUiEntity,
} from '@flowx/designer/modules/core/dictionary/data-model.dictionary'
import { AttributeReferencesComponent } from '@flowx/designer/modules/data-model-builder/components/attribute-references/attribute-references.component'
import { DataModelApiService } from '@flowx/designer/shared/api/data-model.api'
import {
  ApplicationResourceType,
  mapResource,
} from '@flowx/designer/shared/entities/application.entity'
import { expandAttributePathsAndReferences } from '@flowx/designer/shared/entities/data-model.entity'

@Component({
  selector: 'app-data-model-delete-attribute-modal',
  imports: [FlxModalModule, AttributeReferencesComponent, FlxButtonModule, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './data-model-delete-attribute-modal.component.html',
})
export class DataModelDeleteAttributeModalComponent {
  #dataModelApiService = inject(DataModelApiService)
  #flxModalService = inject(FlxModalService)
  @Output() dataEventEmitter = new EventEmitter<{
    attribute: DataModelAttribute
    entityId: DataModelEntity['id']
  }>()

  data = inject<{
    entity: DataModelUiEntity
    attribute: DataModelAttribute
    path: string
    resourceId: string
    resourceType: ApplicationResourceType
  }>(FLX_MODAL_DATA)

  attributeReferences$: Observable<DataModelPathReferences[]>
  hasRelationsOrReferences$: Observable<boolean>
  constructor() {
    effect(() => {
      const resourceId = this.data.resourceId
      const resourceType = this.data.resourceType
      const attributeFlowxUuid = this.data?.attribute.flowxUuid
      if (resourceId && attributeFlowxUuid) {
        this.attributeReferences$ = this.#dataModelApiService
          .getReferencesByAttributeId(
            { resourceId, resourceType },
            this.data.entity.flowxUuid,
            attributeFlowxUuid
          )
          .pipe(
            map((response) => expandAttributePathsAndReferences(mapResource(response))),
            shareReplay(1)
          )

        this.hasRelationsOrReferences$ = this.attributeReferences$.pipe(
          map((refs) =>
            refs.some((res) => res.path !== this.data.path || res.references.length > 0)
          )
        )
      }
    })
  }

  closeModal(): void {
    this.#flxModalService.hide()
  }

  onConfirm(): void {
    this.dataEventEmitter.emit({
      attribute: this.data.attribute,
      entityId: this.data.entity.identifier,
    })
  }
}
